import React from 'react';
import { FeatureExplanationTextWithDataSlotContextBlock } from '@models/feature-explanation';

export const TextWithDataSlotContextExplanationBlock: React.FC<
  FeatureExplanationTextWithDataSlotContextBlock
> = block => <span style={{ whiteSpace: 'pre' }}>{block.text}</span>;
